export default "__VITE_ASSET__ca89932c__"